import { render } from "./AdminBackgrounds.vue?vue&type=template&id=93a04516&scoped=true"
import script from "./AdminBackgrounds.vue?vue&type=script&lang=js"
export * from "./AdminBackgrounds.vue?vue&type=script&lang=js"

import "./AdminBackgrounds.vue?vue&type=style&index=0&id=93a04516&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93a04516"]])

export default __exports__